import userInfoStore from "@/store/user.store";
import UserAvatar from "../UserAvatar";
import IconEditUserName from "@/assets/common/ic_edit_userName.svg?react";
import { useRef, useState } from "react";
import { IDisplayUserInfo, IUserInfo } from "@/types/user";
import UserEditModal, { UserEditModalRef } from "../UserEditModal";
import SwitchCompany from '../../SwitchCompany';
import { defaultAvatarPrefix } from "@/utils/newAvatar";

interface IProps {
  userInfo: IDisplayUserInfo;
}
const UserInfo: React.FC<IProps> = ({ userInfo }) => {
  const { displayName, identityType, companyName, companyRealName } = userInfo;
  const [showCompany, setShowCompany] = useState(false);

  const userEditModalRef = useRef<UserEditModalRef>(null);

  const handleOpenEditModal = () => {
    if (identityType !== 0) return; // 企业账号无法修改信息 
    userEditModalRef.current?.open();
  };

  const handleCallback = (newModel: IDisplayUserInfo) => {
    const { avatarUrl, avatarIndex, ...rest } = newModel;
    const formatNewModel: Partial<IUserInfo> = { ...rest };
    if (avatarUrl || avatarIndex) {
      formatNewModel.avatar =
        avatarUrl || `${defaultAvatarPrefix}${avatarIndex}`;
    }
    userInfoStore.getState().updateUserInfo(formatNewModel);
  };

  const displayCompanyName = identityType === 0 ? '个人账户' : companyName;
  const name = identityType === 0 ? displayName : companyRealName;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={`mt-6 mb-4 mx-4 flex justify-start h-22 border-0 border-b-1 border-#F4F6F9 border-solid ${identityType === 0 ? "cursor-pointer" : ""}`}
        onClick={handleOpenEditModal}
      >
        <UserAvatar userInfo={userInfo} className="w-14 h-14 text-4.5 font-600 mr-3.5" />
        <div className="flex flex-col flex-1">
          <div className="flex items-center font-500 text-4 text-#30343C">
            {name}
            {identityType === 0 && <IconEditUserName className="size-4 ml-1" />}
          </div>
          <div className="mt-1.5 flex items-center cursor-pointer"
            onClick={(e) => {
              setShowCompany(true);
              e.stopPropagation();
            }}>
            <span className="text-3 text-#626773 mr-1.5 lh-4.5 text-ellipsis overflow-hidden break-all line-clamp-2">{displayCompanyName}</span>
            <div className="bg-#4981F21A/10 rounded-1 text-2.5 text-mx-primary px-1.5 h-4.5 lh-4.5 min-w-8 w-8 text-align-center">切换</div>
          </div>
        </div>
      </div>
      {showCompany && <SwitchCompany onClose={() => { setShowCompany(false); }} />}
      <UserEditModal
        ref={userEditModalRef}
        userInfo={userInfo}
        handleCallback={handleCallback}
      />
    </div>
  );
};

export default UserInfo;

